import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { actions } from '../../RestockingState'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { CardItemDetails } from '../../components/CardItemDetails/CardItemDetails'
import * as S from './RestockingPageDetails.styles'
import { Typography } from '@mui/material'

interface Params {
  idPage: string
}

export const RestockingPageDetails = () => {
  const { idPage } = useParams<Params>()

  const history = useHistory()

  const dispatch = useDispatch()
  const { restockingPageDetails } = useSelector((state) => state.restocking)

  useEffect(() => {
    if (idPage) {
      dispatch(actions.getRestockingPageDetails(Number(idPage)))
    }
  }, [dispatch, idPage])

  const goBack = () => {
    if (restockingPageDetails) {
      const { idList } = restockingPageDetails
      dispatch(actions.clearProperty('restockingPageDetails'))
      history.push(`/restocking/manage/pages/${idList}`)
    } else {
      window.history.back()
    }
  }

  return (
    <S.Wrapper>
      <S.CustomButton
        title='Voltar'
        type='button'
        bgColor='blue'
        hoverColor='darkBlueHover'
        letterColor='white'
        onClick={goBack}
        data-testid='back-button-test-id'
      />
      <Typography variant='h5' fontWeight='bold' sx={{ alignSelf: 'center' }}>Detalhes de Página</Typography>
      {restockingPageDetails
      && (
        <>
          <S.GridPageUserInfo>
            <S.CustomTextField
              name='userStarted'
              id='userStarted'
              label='Iniciada por'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-user-started-test-id',
              }}
              value={restockingPageDetails.userStarted || '-'}
            />
            <S.CustomTextField
              name='startedAt'
              id='startedAt'
              label='Iniciada em'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-started-at-test-id',
              }}
              value={restockingPageDetails.startedAt || '-'}
            />
            <S.CustomTextField
              name='userFinished'
              id='userFinished'
              label='Finalizada por'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-user-finished-test-id',
              }}
              value={restockingPageDetails.userFinished || '-'}
            />
            <S.CustomTextField
              name='finishedAt'
              id='finishedAt'
              label='Finalizada em'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-finished-at-test-id',
              }}
              value={restockingPageDetails.finishedAt || '-'}
            />
          </S.GridPageUserInfo>
          <S.GridPageInfo>
            <S.CustomTextField
              name='totalItems'
              id='totalItems'
              label='Qtd. de itens'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-total-items-test-id',
              }}
              value={restockingPageDetails.totalItems}
            />
            <S.CustomTextField
              name='totalSkus'
              id='totalSkus'
              label='Qtd. de SKUs'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-total-skus-test-id',
              }}
              value={restockingPageDetails.totalSkus}
            />
            <S.CustomTextField
              name='totalCollectedQuantity'
              id='totalCollectedQuantity'
              label='Qtd. total coletada'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-total-collected-quantity-test-id',
              }}
              value={restockingPageDetails.totalCollectedQuantity}
            />
            <S.CustomTextField
              name='totalRestockedQuantity'
              id='totalRestockedQuantity'
              label='Qtd. total reposta'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-total-restocked-quantity-test-id',
              }}
              value={restockingPageDetails.totalRestockedQuantity}
            />
            <S.CustomTextField
              name='status'
              id='status'
              label='Status da página'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'page-status-test-id',
              }}
              value={restockingPageDetails.status}
            />
          </S.GridPageInfo>
          {restockingPageDetails?.items.map((item) => (
            <CardItemDetails key={item.idItem} pageItemDetails={item} />
          ))}
        </>
      )}
    </S.Wrapper>
  )
}
